module.exports = __webpack_public_path__ + "img/ttiFullLogo.cbd59797.png";